export default "__VITE_ASSET__CwlHVsgW__"